/** Internal dependencies */
import { apiCall } from './apiCall';
import { handleFilter } from './handleFilter';
import { handleDropdownFilters } from './handleDropdownFilters';
import { handleButtonFilters } from './handleButtonFilters';
import { handleLoadMore } from './handleLoadMore';
import { getCurrentFilters } from './getCurrentFilters';
import { prepareSearch } from './prepareSearch';
import { handleResetButton } from './handleResetButton';
import { handleActiveFiltersContainer } from './handleActiveFiltersContainer';

export function loadAjax(parent) {
    const api = JSON.parse(parent.dataset.rest);

    if (api && api.endpoint.length) {
        const btnLoadMore = parent.querySelector('[data-loadmore]');
        const btnFilter = parent.querySelector('[data-filter-send]');
        const buttonFilters = parent.querySelectorAll('[data-filter-type="button"]');
        const dropdownFilters = parent.querySelectorAll('[data-filter-type="dropdown"]');
        const searchFilter = parent.querySelector('[data-filter-type="search"]');
        const resetButtons = parent.querySelectorAll('[data-filter="reset"]');
        const apiFilter = getCurrentFilters(parent);
        const activeFiltersContainer = parent.querySelector('[data-filters-active]');

        // init
        apiCall(parent, apiFilter, true);

        // Load more button
        if (btnLoadMore) {
            btnLoadMore.addEventListener('click', handleLoadMore);
        }

        // Filter button
        if (btnFilter) {
            btnFilter.addEventListener('click', handleFilter);
        }

        // Handle button filters
        if (buttonFilters) {
            buttonFilters.forEach((filterGroup) => {
                filterGroup.addEventListener('click', handleButtonFilters);
            });
        }

        if (dropdownFilters) {
            dropdownFilters.forEach((filterGroup) => {
                filterGroup.addEventListener('change', handleDropdownFilters);
            });
        }

        if (searchFilter) {
            prepareSearch(searchFilter);
        }

        if (resetButtons) {
            resetButtons.forEach((resetButton) => {
                resetButton.addEventListener('click', handleResetButton);
            });
        }

        if (activeFiltersContainer) {
            activeFiltersContainer.addEventListener('click', handleActiveFiltersContainer);
        }
    }
}
